module.exports = __webpack_public_path__ + "static/mining-city-290b629ce99aa9644ac3f99452010b1a.svg";